export const MEMBERSHIP_PLAN_LABEL_MAP: Record<string, string> = {
    free: 'free',
    plus: '月度 Plus 会员',
    pro: '月度 Pro 会员',
    max: '月度 Max 会员',
    plus_year: '年度 Plus 会员',
    pro_year: '年度 Pro 会员',
    max_year: '年度 Max 会员'
};

export const getMembershipPlanLabel = (plan?: string): string => {
    if (!plan) return '';
    return MEMBERSHIP_PLAN_LABEL_MAP[plan] ?? plan;
};
